import { Outlet } from "react-router-dom";
import NavBarComponent from "../components/nav-bar/NavBarComponent";
import SideMenuComponent from "../components/side-menu/SideMenuComponent";
import FloatingProfilePage from "./FloatingProfilePage";
import { useSelector, useDispatch } from "react-redux";
import classes from "./LayoutPage.module.css";
// import { process.env.REACT_APP_APP_NAME } from "../../configs/constants";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";

import { motion, AnimatePresence } from "framer-motion";

import MenuAdm from "./MenuAdmTransport";
import MenuIT from "./MenuIT";
import MenuPnj from "./MenuPnjTransport";
import MenuKabag from "./MenuKabagTransport";
import MenuStaff from "./MenuSupir";
import MenuKabagKeamanan from "./MenuKabagKeamanan";
import MenuKeamanan from "./MenuKeamanan";
import MenuKabagTransport from "./MenuKabagTransport";
import MenuAdmTransport from "./MenuAdmTransport";
import MenuPnjTransport from "./MenuPnjTransport";
import MenuSupir from "./MenuSupir";
import MenuSD2 from "./MenuSD2";
import useIsMobile from "../hooks/useIsMobile";

const title = process.env.REACT_APP_APP_NAME;
const logoUrl = `${process.env.REACT_APP_MY_URL}/logo128.png`;

const handleNotifClick = (e) => {
  console.log("New Notif Click");
};

const LayoutPage = () => {
  const employee = useSelector((state) => state.auth.employee);
  const permissions = useSelector((state) => state.auth.permissions);
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const sideMenuIsVisible = useSelector((state) => state.ui.sideMenuIsVisible);

  const isMobile = useIsMobile();

  const handleAvatarClick = (e) => {
    setShowProfileDialog((state) => !state);
  };
  // console.log("Permissions:", permissions);

  const getMenus = () => {
    // console.log(permissions);

    if (permissions.includes("view kabag-keamanan")) {
      // console.log("MENU KABAG KEAMANAN");
      return MenuKabagKeamanan;
    } else if (permissions.includes("view keamanan")) {
      // console.log("MENU KEAMANAN");
      return MenuKeamanan;
    } else if (permissions.includes("view kabag-transport")) {
      // console.log("MENU KABAG TRANSPORT");
      return MenuKabagTransport;
    } else if (permissions.includes("view sd2")) {
      // console.log("MENU SD2");
      return MenuSD2;
    } else if (permissions.includes("view adm-transport")) {
      // console.log("MENU ADM TRANSPORT");
      return MenuAdmTransport;
    } else if (permissions.includes("view pnj-transport")) {
      // console.log("MENU PNJ TRANSPORT");
      return MenuPnjTransport;
    } else if (permissions.includes("view supir")) {
      // console.log("MENU SUPIR");
      return MenuSupir;
    } else if (permissions.includes("view it")) {
      // console.log("MENU IT");
      return MenuIT;
    }
    return [];
  };

  return (
    <>
      <div className="row-start-start w-100">
        <AnimatePresence>
          {sideMenuIsVisible && (
            <SideMenuComponent
              menus={getMenus()}
              title={title}
              logoUrl={logoUrl}
            />
          )}
        </AnimatePresence>
        <Dialog
          className="mt-6"
          showHeader={false}
          contentStyle={{ padding: "0", borderRadius: "0.5rem" }}
          position={"top-right"}
          visible={showProfileDialog}
          modal={false}
          style={{
            width: "50vw",
            marginTop: "calc(var(--height-nav-bar) + 12px )",
          }}
          draggable={false}
          resizable={false}
          onHide={() => setShowProfileDialog(false)}
        >
          <FloatingProfilePage hidden={false} />
        </Dialog>
        <motion.div
          initial={
            isMobile
              ? {}
              : {
                marginLeft: sideMenuIsVisible ? 0 : "var(--width-side-menu)",
                width: "calc(100% - var(--width-side-menu))",
              }
          }
          animate={
            isMobile
              ? {}
              : {
                marginLeft: sideMenuIsVisible ? "var(--width-side-menu)" : 0,
                width: sideMenuIsVisible
                  ? "calc(100% - var(--width-side-menu))"
                  : "100%",
              }
          }
          className={`col-start-start w-100 `}
        >
          <NavBarComponent
            className="w-100"
            showNotif={true}
            onCLickAvatar={handleAvatarClick}
            onClickNotif={handleNotifClick}
            avatarSrc={employee ? employee.image : ""}
          />
          <main className={`row-start-start ${classes.mainContainer} w-full`}>
            <Outlet />
          </main>
        </motion.div>
      </div>
    </>
  );
};

export default LayoutPage;
